import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import F84Game from "../Game";
import ARIA from "../utils/ARIA";
import BaseURL from "../utils/BaseURL";
import Fonts from "../utils/Fonts";
import WebPlayerData from "../WebPlayerData";
import LoaderScene from "./LoaderScene";

export default class BootScene extends LoaderScene {
	loaded: boolean;
	partnerLoaded: boolean;

	preload(): void {
		console.log("preload");
		console.log(F84Game.Instance.locale);

		this.load.setBaseURL(BaseURL.getBaseURL());

		const playerData = new WebPlayerData("lumi-ski-training");
		playerData.load();

		this.load.script("file-saver", "./libs/FileSaver.js");

		this.loadImages("./assets/images/temp/", {
			whiteCircle: "white-circle",
			whiteSquare: "white-square",
		});

		this.loadImages("./assets/images/loading/ag-lumi-loading-", {
			loadingBarBG: "meter",
			loadingBarFill: "fill",
		});

		this.loadImages("./assets/images/splash/", {
			splashBG: "ag-lumi-ski-splash-bg-2",
		});

		this.loadImages("./locale/images/" + F84Game.Instance.locale + "/", {
			loadingLogo: "ag-lumi-loading-logo-2",
		});

		this.loadImage("rotateDevice", "./assets/images/system/orientation.png");

		this.loadJson("strings", "./locale/strings.json", false);
		this.loadJson("gameConfig", "./assets/json/game-config.json", false);
		this.loadJson("chunks", "./assets/json/chunks.json", false);

		this.load.webfont(Fonts.Chewy, Fonts.Chewy);
		this.load.webfont(Fonts.Titanone, Fonts.Titanone);
		this.load.webfont(Fonts.DisneyJr, Fonts.DisneyJr);
		this.load.webfont(Fonts.DisneyJrBold, Fonts.DisneyJrBold);
		this.load.webfont(Fonts.MontserratBold, Fonts.MontserratBold);
		this.load.webfont(Fonts.MontserratExtraBold, Fonts.MontserratExtraBold);
	}

	create(): void {
		super.create();
		GameConfig.loadConfigFile(this.cache, "gameConfig");
		console.log(Strings.get("GameTitle"));

		const destinationScene = GameConfig.get("startScene");
		console.log("destinationScene: " + destinationScene);

		ARIA.init();
		this.game.scene.start("PreloaderScene", {
			destinationScene: destinationScene,
			initalLoad: true,
		});
	}
}
